import { BaseCalculatorTab } from "../../../../tabs/calculatorResults/baseCalculatorTab";
import { Component, Input, OnInit } from "@angular/core";
import { Order } from "../../../../../../objects/orders/order";
import { CalculatorHelper } from "../../../../../../common/helpers/calculatorHelper";
import { OrderItem } from "../../../../../../objects/orders/orderItem";
import { TaxService } from "../../../../../../services/calculator/tax.service";
import { OrderOptions } from "../../../../../../objects/orders/orderOptions";

@Component({
    selector: "canadian-results-v2",
    templateUrl: "./canadian-results-v2.component.html",
    moduleId: module.id.toString()
})
export class CanadianResultsV2Component extends BaseCalculatorTab implements OnInit {

    @Input()
    public order: Order;
    @Input()
    public orderItem: OrderItem;

    public showHst: boolean = false;
    public showQst: boolean = false;
    public OrderOptions = OrderOptions;
    public calculatorHelper = CalculatorHelper;

    public get currency(): string {
        return CalculatorHelper.getCurrencyName(this.order);
    }

    public constructor(public taxService: TaxService){
        super();
    }

    public ngOnInit(): void {
        this.setHQst();
    }

    private setHQst() : void{
       const isHQst = CalculatorHelper.isHQst(this.order);

       if(isHQst == null)
           return;

       if(isHQst == true)
           this.showHst = true;

       if(isHQst == false)
           this.showQst = true;
    }
}



// WEBPACK FOOTER //
// ./app/components/calculator/public/mobile/result-tab/canadian/canadian-results-v2.component.ts